module.exports = __webpack_public_path__ + "img/light_2.b2e64f22.png";